export enum ShiftsRoutesEnum{
    SHIFTS_PREFIX           = 'shifts',
    SHIFTS_LIST             = 'shifts_list',
    SHIFTS_DETAIL           = 'shifts_detail',
    SHIFTS_KPI              = 'shifts_kpi',
    SHIFTS_TICKETS_HISTORY  = 'shifts_tickets_history',

    SHIFTS_DETAIL_TICKETS = "shifts_detail_tickets"
}
